import React from 'react';
import CTA from '../components/CTA';
import ProductGrid from '../components/ProductGrid';

const Home = () => {
    return (
        <>

            {/* Produtos em Destaque */}
            <ProductGrid />

            <section id="question" style={{
                backgroundColor: '#000000',
                color: '#ffffff',
                padding: '40px 0',
                margin: '0',
                width: '100vw',
                marginLeft: 'calc(-50vw + 50%)',
                textAlign: 'center'
            }}>
                <header style={{ margin: '0', padding: '0' }}>
                    <h2 style={{ margin: '0', padding: '0', fontWeight: 'bold' }}>Por que escolher um brinquedo sensorial da GM 3D?</h2>
                </header>
            </section>

            {/* Highlights */}
            <section className="wrapper style1">
                <div className="container">
                    <div className="row gtr-200">
                        <section className="col-3 col-12-narrower">
                            <div className="box highlight">
                                <i className="icon solid major fa-hand-sparkles"></i>
                                <h3>Estímulo Positivo</h3>
                                <p>Brinquedos projetados para auxiliar no desenvolvimento sensorial de crianças neurodivergentes.</p>
                            </div>
                        </section>
                        <section className="col-3 col-12-narrower">
                            <div className="box highlight">
                                <i className="icon solid major fa-heartbeat"></i>
                                <h3>Conforto e Alívio</h3>
                                <p>Peças que ajudam a aliviar a ansiedade e promover foco por meio de texturas e interação tátil.</p>
                            </div>
                        </section>
                        <section className="col-3 col-12-narrower">
                            <div className="box highlight">
                                <i className="icon solid major fa-cogs"></i>
                                <h3>Qualidade Extrema</h3>
                                <p>Usamos as impressoras 3D mais tecnológicas do mercado para garantir qualidade impecável, visual
                                    requintado e foco total em segurança.</p>
                            </div>
                        </section>
                        <section className="col-3 col-12-narrower">
                            <div className="box highlight">
                                <i className="icon solid major fa-shield-alt"></i>
                                <h3>Materiais Seguros</h3>
                                <p>
                                    Utilizamos apenas os materiais PLA¹ e PETG².
                                    Ambos atóxicos, sustentáveis e ideais para produtos voltados ao público infantil e sensível.
                                </p>
                            </div>
                        </section>
                        <small style={{ fontSize: '1.1rem' }}>
                            1 - PLA: Plástico biodegradável feito de fontes renováveis como milho, cana-de-açúcar e café. Seguro para contato frequente, ideal para brinquedos e itens manuseados por crianças e adultos sensíveis.<br />
                            2 - PETG: Plástico resistente e reciclável, derivado do PET. Durável e seguro, livre de toxinas. Excelente para produtos que exigem resistência e contato seguro com a pele.
                        </small>
                    </div>
                </div>
            </section>

            <CTA />
        </>
    );
};

export default Home;
